import { api, setConfig, UPDATE_GAME_CATEGORY_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const addNewGameProvider = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/providers/create', mapEntityToApi(data), setConfig(data)).then((res) => {
		return { message: UPDATE_GAME_CATEGORY_MESSAGE, gameProvider: res.data };
	});
